import { MdClose } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import SimpleBlock from '../Block'

import './styles.scss'

const CloseButtonBlock = (props: IBlockProps): ReactElement => {
  return (
    <SimpleBlock {...props} type="close-button">
      <MdClose />
    </SimpleBlock>
  )
}

export default CloseButtonBlock
